export const init = () => {
  const observer = new MutationObserver(() => {
    const switcherTabs2 = document.querySelectorAll('.s-switcher-tab--type-2');
    if (!switcherTabs2.length) return;

    observer.disconnect(); // Odpojí observer během inicializace, aby se vyhnul nekonečné smyčce

    switcherTabs2.forEach(switcherTab => {
      // Kontrola, zda již byl přepínač inicializován 
      if (switcherTab.dataset.initialized === 'true') return;

      const links = switcherTab?.querySelector('.s-switcher-tab__links');


      if (links.scrollWidth > links.clientWidth) {
        switcherTab?.classList.add("js-s-switcher-tab-scroll-x");
      }


      // Označení přepínače jako inicializovaného
      switcherTab.dataset.initialized = 'true';
    });

    // Opětovné připojení observeru po dokončení inicializace
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};


